var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGroceries64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18221)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0843 18.5996L21.5469 12.1323H28.7862L31.2488 18.5996C31.6719 19.7109 31.8888 20.89 31.8888 22.079V32.5027H18.4443V22.079C18.4443 20.89 18.6612 19.7109 19.0843 18.5996Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6324 8.05835H20.7007C20.0257 8.05835 19.4785 8.60556 19.4785 9.28057V10.9102C19.4785 11.5852 20.0257 12.1324 20.7007 12.1324H29.6324C30.3074 12.1324 30.8546 11.5852 30.8546 10.9102V9.28057C30.8546 8.60556 30.3074 8.05835 29.6324 8.05835Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7374 17.3796C30.5962 16.7442 31.8409 16.3315 33.1152 16.6496C33.9488 16.8577 34.7952 17.773 35.5544 17.773C36.4304 17.773 37.4003 16.8472 38.3399 16.6639C39.6328 16.4117 40.8683 16.9495 41.7223 17.6537C43.5629 19.1711 44.3933 22.155 44.0259 24.6665C43.4746 28.4346 41.4715 31.3621 38.3923 32.464C36.5106 32.6739 36.7646 31.9621 35.5544 31.9621C35.0952 31.9621 34.8476 32.066 34.6128 32.1821L34.456 32.2602C34.1148 32.4273 33.7097 32.5777 32.6613 32.4437C29.6124 31.3255 27.6308 28.4111 27.083 24.6665C26.6927 21.9992 27.6958 18.89 29.7374 17.3796Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5194 12.9473C36.5953 12.9473 35.4756 14.072 35.4756 16.9274",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1166 29.0303L32.5801 30.4657L34.024 29.0203L36.6502 26.3916L40.7774 30.4657L44.9702 26.3916L48.9363 30.4657L49 56.9472H16V30.4657L20.125 26.3916L24.2455 30.4657L28.4264 26.3916L31.1166 29.0303Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGroceries64);
export default __webpack_public_path__ + "static/media/pictogramBeaconGroceries64.163caf0afaaa72df05588933e29975e1.svg";
export { ForwardRef as ReactComponent };